// src/contexts/ThemeContext.jsx

import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // 1. LEER: Al iniciar, intenta obtener el tema guardado. Si no existe, usa 'light'.
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
  
  // 2. LEER: Hace lo mismo para los colores de estilo.
  const [positiveColor, setPositiveColor] = useState(() => localStorage.getItem('positiveColor') || '#10b981');
  const [negativeColor, setNegativeColor] = useState(() => localStorage.getItem('negativeColor') || '#ef4444');

  useEffect(() => {
    // Lógica para el modo oscuro/claro
    if (theme === 'dark') {
      document.body.classList.add('dark');
      document.body.classList.remove('light');
    } else {
      document.body.classList.add('light');
      document.body.classList.remove('dark');
    }
    
    // 3. GUARDAR: Cada vez que un color cambie, lo guarda en localStorage.
    localStorage.setItem('theme', theme);
    document.body.style.setProperty('--positive-color', positiveColor);
    document.body.style.setProperty('--negative-color', negativeColor);
    localStorage.setItem('positiveColor', positiveColor);
    localStorage.setItem('negativeColor', negativeColor);

  }, [theme, positiveColor, negativeColor]);

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  const updateStyleColors = (newPositive, newNegative) => {
    setPositiveColor(newPositive);
    setNegativeColor(newNegative);
  };

  const value = {
    theme,
    toggleTheme,
    positiveColor,
    negativeColor,
    updateStyleColors,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};